export const getAllCategories = (
    object: Array<{ categories?: string[], status:string }>,
    array: string[],
    gameBoxView: string
): string[] => {
  let categories = array;
  object.forEach((item) => {
    if (item.categories && item.status !== "completed") {
      categories = categories.concat(item.categories);
      if (item.categories[0] === null && gameBoxView === "widget") {
        categories = categories.concat(['other']);
      }
    }
  });
  return categories;
}

export const getAllCategoriesWithoutProgressive = (
    object: Array<{ categories?: string[], progressive_mission_id?: any, status: string }>,
    array: string[]
): string[] => {
  let categories = array;
  const filteredMissions = object.filter(
      (item) => item.status !== 'completed'
  );
  filteredMissions.forEach((item) => {
    if (item.categories && !item.progressive_mission_id) {
      categories = categories.concat(item.categories);
    }
  });
  return categories;
}

export const prop = <T>(key: keyof T) => (obj: T): any => obj?.[key];

export const stringToLiteral = (value: string): any => {
  if (value === "undefined") return undefined;
  else if (value === "null") return null;
  else return value;
};

export const maskString = (str: string): string | undefined => {
  if (!str || typeof str !== 'string') return;
  const mask = '*';
  let firstTwoLetters: string;
  let lastTwoLetters: string;
  let countOfMask: number;
  if (str.length < 7) {
    firstTwoLetters = str.slice(0, 2);
    lastTwoLetters = str.slice(-1);
    countOfMask = str.length - 3;
  } else {
    firstTwoLetters = str.slice(0, 3);
    lastTwoLetters = str.slice(-2);
    countOfMask = str.length - 5;
  }
  const generatedMask = Array.from(Array(countOfMask).keys()).map(() => mask).join('');
  return `${firstTwoLetters}${generatedMask}${lastTwoLetters}`;
}

export const numberIsFixed = (num: number, digit: number = 2): string | number => {
  if (isNaN(num)) {
    return 'Invalid input';
  } else {
    if (Number.isInteger(num)) {
      return num;
    } else {
      return num.toFixed(digit);
    }
  }
};

export const appendToken = (url: string, token: string): string => {
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}token=${token}`;
};

export const getSubmissions = (gameBoxType: string, expiredMissionData: any) => {
  const { emptySubmissions, nonEmptySubmissions } =
  expiredMissionData?.[gameBoxType]?.reduce(
      (
          acc: { emptySubmissions: any[]; nonEmptySubmissions: any[] },
          data: { id: number; submissions: string[] }
      ) => {
        if (!data?.submissions?.length) {
          acc.emptySubmissions.push({ ...data });
        } else {
          acc.nonEmptySubmissions.push({ ...data });
        }
        return acc;
      },
      { emptySubmissions: [], nonEmptySubmissions: [] }
  ) || { emptySubmissions: [], nonEmptySubmissions: [] };

  return { emptySubmissions, nonEmptySubmissions };
};